import { fmtBrl } from '../shared/formatters'
import { sumOrNull } from '../shared/math'

const resolveUnitCost = ({ hybridAgg, cmvAgg, i, usePriceCostAsCMV }) => {
  const baseCost = hybridAgg[i]?._unitCost ?? null;

  if (!usePriceCostAsCMV) return baseCost;

  return cmvAgg?.[i]?._cmvUnitCost ?? baseCost;
};

const resolveCmvTotal = ({ hybridAgg, i }) => {
  const unitsSold = hybridAgg[i]?._unitsSold;
  const unitCost = hybridAgg[i]?._unitCost;

  return (unitsSold != null && unitCost != null) ? unitsSold * unitCost : null;
};

const buildCmvUnitarioRow = ({
  monthKeys,
  hybridAgg,
  cmvAgg,
  usePriceCostAsCMV = true,
}) => {
  const rawValues = monthKeys.map((_, i) =>
    resolveUnitCost({ hybridAgg, cmvAgg, i, usePriceCostAsCMV })
  );

  return {
    values: rawValues.map(v => v != null ? fmtBrl(v) : null),
    rawValues,
  };
};

const buildCmvTotalRow = ({
  monthKeys,
  hybridAgg,
  cmvAgg,
  usePriceCostAsCMV = true,
}) => {
  const rawValues = monthKeys.map((_, i) =>
    resolveCmvTotal({ hybridAgg, cmvAgg, i, usePriceCostAsCMV })
  );

  const values = rawValues.map(v => v != null ? fmtBrl(v) : null);

  const s1 = sumOrNull(rawValues.slice(0, 6));
  const s2 = sumOrNull(rawValues.slice(6, 12));
  const total = (s1 != null || s2 != null) ? (s1 ?? 0) + (s2 ?? 0) : null;

  return {
    values,
    rawValues,
    semValues: [s1, s2, total].map(v => v != null ? fmtBrl(v) : null),
    semRawValues: [s1, s2, total],
  };
};

export const cmv = {
  buildCmvUnitarioRow,
  buildCmvTotalRow,
  resolveCmvTotal
}